import vendors from '@/configurations/general/vendors'
import Query from '@/classes/queries/Query'

const VENDORS = vendors.filter(({ regex }) => !!regex)

export const useVendors = () => {
  const video_vendors = VENDORS.filter(({ category }) => category === 'video')

  const getVendor = name => vendors.find(vendor => vendor.name === name)

  const isVendorAllowed = url => VENDORS.some(({ regex }) => regex?.test(url))

  const isEmbedVideoUrl = url => video_vendors.some(({ regex }) => regex?.test(url))

  const isIframeSrcAllowed = iframe => {
    const [, src] = iframe.match(/src\s*=\s*["']([^"']+)["']/i)

    return isVendorAllowed(src)
  }

  const getVendorByUrl = url => vendors.find(vendor => vendor.regex?.test(url))

  const getVendorUrl = ({ src, params = {} }) => {
    const vendor = getVendorByUrl(src)

    if (!vendor) return ''

    const query = new Query({ query: { ...vendor?.params, ...params } }).to_string
    const url = src.replace(vendor.regex, vendor.url)

    return url + query.replace('?', url.includes('?') ? '&' : '?')
  }

  const getVendorRegexExpression = ({ name, flags }) => {
    const vendor = getVendor(name)

    return vendor ? new RegExp(vendor.regex.source, flags || vendor.regex.flags) : new RegExp('')
  }

  return {
    vendors,
    video_vendors,
    isVendorAllowed,
    isEmbedVideoUrl,
    isIframeSrcAllowed,
    getVendor,
    getVendorByUrl,
    getVendorUrl,
    getVendorRegexExpression
  }
}